<template>
  <div class="drive-action-bar">
    <div class="row">
      <div class="col-md-6">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search files..."
            v-model="localQuery"
            @keyup.enter="$emit('search', localQuery)"
          />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="$emit('search', localQuery)">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
            <button
              v-if="localQuery"
              class="btn btn-default"
              type="button"
              @click="localQuery = ''; $emit('search', '')"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="col-md-6 text-right">
        <ul class="o-filter-area">
          <li>
            <a
              href="javascript: void(0)"
              @click="$emit('toggle-view')"
              class="c-solid-btn"
            >
              <i
                :class="viewMode === 'list' ? 'fa fa-th-large' : 'fa fa-list'"
                aria-hidden="true"
              ></i>
              {{ viewMode === "list" ? " Grid" : " List" }}
            </a>
          </li>
          <li v-if="canUpload">
            <a href="javascript: void(0)" class="c-solid-btn c-solid-btn--green" @click="$emit('upload')">
              <i class="fa fa-upload" aria-hidden="true"></i> Upload
            </a>
          </li>
          <li v-if="isAdmin">
            <a href="javascript: void(0)" class="c-solid-btn c-solid-btn--green" @click="$emit('new-folder')">
              <i class="fa fa-folder-o" aria-hidden="true"></i> New Folder
            </a>
          </li>
          <li v-if="isAdmin">
            <a href="javascript: void(0)" class="c-solid-btn" @click="$emit('manage-groups')">
              <i class="fa fa-users" aria-hidden="true"></i> User Groups
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DriveActionBar",
  props: {
    searchQuery: { type: String, default: "" },
    viewMode: { type: String, default: "list" },
    isAdmin: { type: Boolean, default: false },
    canUpload: { type: Boolean, default: false },
  },
  data() {
    return {
      localQuery: this.searchQuery,
    };
  },
  watch: {
    searchQuery: function (val) {
      this.localQuery = val;
    },
  },
};
</script>

<style scoped>
.drive-action-bar {
  margin-bottom: 15px;
  padding: 10px 0;
}
.o-filter-area {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  gap: 8px;
}
</style>
